import List from '@utils/list'
import http from '@plugin/axios'
import DetailTemplate from '@/views/purchaser/bidmanagementpur/mybidding/detail/detail.vue'
const { Search, Table, Tabs, Detail, Operation } = List
const tabs = new Tabs()
  .api(function() {
    return http<any[]>({
      url: '/srmBiddingHead/getBiddingCount',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: {}
    }).then(res => {
      return res.map(item => ({ ...item, status: `${item.status}-${item.releaseStatus}` }))
    })
  })
  .name('statusName')
  .value('status')
  .count('statusCount')
  .prop('status')
  .default('0-0')

const search = new Search('bidmanagementsup.mybidding')
  .placeholder('searchPlaceholder')
  .add('purOfficeNo').select('/purchaseUnit/getPurchaseUnitPage')
  .add('biddingMode').op('modeOptions')
  .lib('dateTimeRange').label('dateTimeRange').prop(['beginStartTime', 'endStartTime'])

const table = new Table('bidmanagementsup.mybidding')
  .type('index')
  .add('biddingNo').link()
  .add('biddingName')
  .add('biddingMode').op('modeOptions')
  .add('releaseDate').width(160)
  .add('startTime').width(160)
  .add('endTime').width(160)
  .add('biddingSupplierCount')
  .add('statusName')

// 列表接口
function getData(data: any) {
  const [status, releaseStatus] = (data.condition.status || '').split('-')
  const params = {
    ...data,
    condition: {
      ...data.condition,
      status,
      releaseStatus,
      field: 'startTime'
    }
  }
  return http({
    url: '/srmBiddingHead/getBiddingPage',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: params
  })
}

const detail = new Detail()
  .template(DetailTemplate)

function gotoBiddinghall(this: any, data: any) {
  this.$router.push({ name: 'Bidmanagementsup.Mybidding.Biddinghall', params: { id: data.id }})
}

function gotoBiddingresult(this: any, data: any) {
  this.$router.push({ name: 'Bidmanagementsup.Mybidding.Biddingresult', params: { id: data.id }})
}

const operation = new Operation('bidmanagementsup.mybidding')
  .width(150)
  .add('biddinghall').disabled(data => !(data.status >= 2 && data.biddingStatus !== '1')).handle(gotoBiddinghall)
  .add('seeDetail').disabled(data => !(data.status === '3' && data.resultSendSign === 'Y')).handle(gotoBiddingresult)

export default new List()
  .api(getData)
  .operation(operation)
  .tabs(tabs)
  .table(table)
  .search(search)
  .detail(detail)
  .end()
